/* global axios */

export default {
  getAttributes(accountId, contactId) {
    return axios.get(`/api/v1/accounts/${accountId}/contacts/${contactId}/attributes`);
  },
};
